import React from "react"
import { Layout } from "antd"
import styles from "./index.module.css"
import { Outlet } from "react-router-dom"
import { ClientsBreadcrumb } from "./Breadcrumb"
import classNames from "classnames"

export const ProClientsLayout = () => {
  return (
    <Layout className={classNames(styles.layout)}>
      <ClientsBreadcrumb />
      <Outlet />
    </Layout>
  )
}
